import { MILLISECONDS_IN_DAY, DAYS, EXAMPLE_MESSAGE, EXPIRY_REGEX, HOURS, MILLISECONDS_IN_HOUR, MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_YEAR, MINUTES, MONTHS, YEARS, ALLOWED_MEASUREMENTS, } from './constants';
export const parseExpiry = (expiryValue) => {
    if (typeof expiryValue === 'number')
        return expiryValue;
    if (typeof expiryValue !== 'string')
        throw new Error(`Wrong expiry type - ${typeof expiryValue}. ${EXAMPLE_MESSAGE} `);
    const regexResult = EXPIRY_REGEX.exec(expiryValue);
    EXPIRY_REGEX.lastIndex = 0;
    if (!regexResult)
        throw new Error(`Wrong expiry value. ${EXAMPLE_MESSAGE} `);
    const [_, _value, measurement] = regexResult;
    const value = +_value;
    if (value < 1)
        throw new Error(`Number should be integer & bigger than 0, you provided - ${value}`);
    if (!ALLOWED_MEASUREMENTS.includes(measurement))
        throw new Error(`Wrong measurement value. ${EXAMPLE_MESSAGE}`);
    const currentDate = new Date();
    const currentTime = currentDate.getTime();
    switch (measurement) {
        case MINUTES:
            return currentTime + value * MILLISECONDS_IN_MINUTE;
        case HOURS:
            return currentTime + value * MILLISECONDS_IN_HOUR;
        case DAYS:
            return currentTime + value * MILLISECONDS_IN_DAY;
        case MONTHS:
            const expiryDate = currentDate.setMonth(currentDate.getMonth() + value);
            return expiryDate;
        case YEARS:
            return currentTime + value * MILLISECONDS_IN_YEAR;
        default:
            throw new Error(`Impossible error. The measurement is - ${measurement}`);
    }
};
//# sourceMappingURL=parseExpiry.js.map